import { render, staticRenderFns } from "./Sell-asale.vue?vue&type=template&id=0ecc132b&scoped=true&"
import script from "./Sell-asale.vue?vue&type=script&lang=js&"
export * from "./Sell-asale.vue?vue&type=script&lang=js&"
import style0 from "./Sell-asale.vue?vue&type=style&index=0&id=0ecc132b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecc132b",
  null
  
)

export default component.exports